// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__rUEpD","modal":"Modal_modal__Jg4qe","slide-down":"Modal_slide-down__5TKao"};